import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { TaskCard } from './TaskCard';
import { Plus } from 'lucide-react';

const COLUMN_CONFIG = {
  inbox: { label: 'Inbox', color: 'bg-zinc-500' },
  next_up: { label: 'Next Up', color: 'bg-blue-500' },
  in_progress: { label: 'In Progress', color: 'bg-yellow-500' },
  done: { label: 'Done', color: 'bg-emerald-500' },
};

export function KanbanColumn({ columnId, tasks, onEditTask }) {
  const { setNodeRef, isOver } = useDroppable({ id: columnId });
  const config = COLUMN_CONFIG[columnId];
  const taskIds = tasks.map(t => t.id);

  return (
    <div 
      className="flex-1 min-w-[280px] max-w-[320px] flex flex-col"
      data-testid={`kanban-column-${columnId}`}
    >
      {/* Column Header */}
      <div className="flex items-center gap-3 mb-4 px-1">
        <div className={`w-2 h-2 rounded-full ${config.color}`} />
        <h3 className="text-sm font-medium text-zinc-100 font-['Outfit'] tracking-tight">
          {config.label}
        </h3>
        <span className="text-xs text-zinc-500 ml-auto">{tasks.length}</span>
      </div>

      {/* Column Body */}
      <div
        ref={setNodeRef}
        className={`flex-1 p-2 rounded-xl border transition-colors duration-200 min-h-[200px] ${
          isOver 
            ? 'bg-white/5 border-white/20' 
            : 'bg-[#0D0D0F] border-white/5'
        }`}
      >
        <SortableContext items={taskIds} strategy={verticalListSortingStrategy}>
          <div className="space-y-3">
            {tasks.map((task) => (
              <TaskCard key={task.id} task={task} onEdit={onEditTask} />
            ))}
          </div>
        </SortableContext>

        {tasks.length === 0 && (
          <div className="h-full flex items-center justify-center py-8">
            <p className="text-xs text-zinc-600 text-center">
              Dra uppgifter hit
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
